module.exports = __webpack_public_path__ + "static/media/ArrowDownSuccess.cdcc7d68.svg";